import { Columns } from '@app/components/simple-table/simple-table.component';

export const taxFormContactTableColumns: Columns[] = [
    { columnName: 'payroll.settings.name', columnSpan: 'columns-3' },
    { columnName: 'payroll.settings.email', columnSpan: 'columns-3' },
    { columnName: 'payroll.settings.phone', columnSpan: 'columns-3' },
    { columnName: 'payroll.settings.extension', columnSpan: 'columns-2' },
];
